import React, { Component } from 'react'

import css from './style.module.css'
import FontIcon from '../../../SPRINTA/atoms/FontIcon'

export default class RadioBox extends Component {
    render() {
        const { text, icon, title, ...props } = this.props 
        return (
            <label className={css.radioBox}>
                <input type='radio' {...props} />
                <div className={css.contentBox}>
                    {icon && (
                        <div className={css.icon}>
                            <FontIcon name={icon} />
                        </div>
                    )}
                    <div className={css.content}>
                        <div className={css.title} dangerouslySetInnerHTML={{__html: title}} />
                        <div className={css.text} dangerouslySetInnerHTML={{__html: text}} />
                    </div>
                </div>
            </label>
        )
    }
}


// WEBPACK FOOTER //
// ./src/SPRINTA/molecules/RadioBox/index.js